'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class; // Lib


// Utils


// Actions


// Components


// Selector


// Constants


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _milanoteForm = require('../../../../components/form/milanoteForm');

var _milanoteForm2 = _interopRequireDefault(_milanoteForm);

var _formSubmissionExceptionHandler = require('../../../../components/form/formSubmissionExceptionHandler');

var _formSubmissionExceptionHandler2 = _interopRequireDefault(_formSubmissionExceptionHandler);

var _currentUserActions = require('../../../currentUserActions');

var _FormInput = require('../../../../components/form/fields/FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

var _FieldValidationMessages = require('../../../../components/form/validation/FieldValidationMessages');

var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);

var _LinkButton = require('../../../../components/buttons/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

var _currentUserSelector = require('../../../currentUserSelector');

var _validationConstants = require('../../../../../common/validation/validationConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FORM_NAME = 'userName';

var USERNAME_FIELDS = {
    givenName: _validationConstants.FIELDS.givenName,
    familyName: _validationConstants.FIELDS.familyName
};

var mapStateToProps = function mapStateToProps(state) {
    var currentUser = (0, _currentUserSelector.getCurrentUser)(state);
    return {
        initialGivenName: currentUser.getIn(['name', 'givenName']),
        initialFamilyName: currentUser.getIn(['name', 'familyName'])
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        onSubmit: function onSubmit(_ref) {
            var givenName = _ref.givenName,
                familyName = _ref.familyName;
            var onSubmit = ownProps.onSubmit,
                initialGivenName = ownProps.initialGivenName,
                initialFamilyName = ownProps.initialFamilyName;


            if (initialGivenName === givenName && initialFamilyName === familyName) {
                onSubmit();
                return;
            }

            var userChanges = {
                name: {
                    givenName: givenName,
                    familyName: familyName,
                    displayName: givenName + ' ' + familyName
                }
            };

            return dispatch((0, _currentUserActions.updateCurrentUserHtpp)(userChanges)).then(onSubmit).catch((0, _formSubmissionExceptionHandler2.default)({ dispatch: dispatch, form: FORM_NAME }));
        }
    };
};

var mapStateToForm = function mapStateToForm(state) {
    var currentUser = (0, _currentUserSelector.getCurrentUser)(state);
    return {
        initialValues: {
            givenName: currentUser.getIn(['name', 'givenName']),
            familyName: currentUser.getIn(['name', 'familyName'])
        }
    };
};

var UserNameForm = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec2 = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec3 = (0, _milanoteForm2.default)({ form: FORM_NAME, fieldsConfig: USERNAME_FIELDS }, mapStateToForm), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
    _inherits(UserNameForm, _React$Component);

    function UserNameForm() {
        _classCallCheck(this, UserNameForm);

        return _possibleConstructorReturn(this, (UserNameForm.__proto__ || Object.getPrototypeOf(UserNameForm)).apply(this, arguments));
    }

    _createClass(UserNameForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.givenName.focus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                submitInterceptor = _props.submitInterceptor,
                sanitisedErrors = _props.sanitisedErrors;


            return _react2.default.createElement(
                'div',
                { className: 'UserNameForm' },
                _react2.default.createElement(
                    'form',
                    { onSubmit: submitInterceptor },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-fields' },
                        _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: function ref(c) {
                                _this2.givenName = c;
                            },
                            name: USERNAME_FIELDS.givenName.name,
                            type: USERNAME_FIELDS.givenName.type,
                            placeholder: 'First name',
                            maxLength: USERNAME_FIELDS.givenName.maxLength })),
                        _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'familyName',
                            name: USERNAME_FIELDS.familyName.name,
                            type: USERNAME_FIELDS.familyName.type,
                            placeholder: 'Last name',
                            maxLength: USERNAME_FIELDS.familyName.maxLength }))
                    ),
                    _react2.default.createElement(
                        _LinkButton2.default,
                        { type: 'submit' },
                        'Done'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'errors' },
                    _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.givenName }),
                    _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.familyName })
                )
            );
        }
    }]);

    return UserNameForm;
}(_react2.default.Component)) || _class) || _class) || _class);


UserNameForm.propTypes = {
    onSubmit: _propTypes2.default.func,
    submitInterceptor: _propTypes2.default.func,
    sanitisedErrors: _propTypes2.default.object
};

exports.default = UserNameForm;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/settings/editableUserName/UserNameForm.js
// module id = 2090
// module chunks = 0